import { InhalerCompliance } from '@/jsonapi/CommonTypes'

export function getAdherenceRateChartOptions(inhalerCompliance: InhalerCompliance[]) {
  if (!inhalerCompliance || inhalerCompliance.length === 0) {
    return {}
  }

  const adherePercent = inhalerCompliance[0].compliancePerc
  const nonAdherePercent = 100 - adherePercent
  const adhereText = `${adherePercent}% Compliant`
  const nonAdhereText = `${nonAdherePercent}% Non-Compliant`
  return {
    legend: {
      selectedMode: false,
      orient: 'vertical',
      right: 10,
      top: -5,
      silent: true,
      textStyle: {
        fontWeight: 'bold',
      },
      formatter: function(params) {
        return params
      },
      data: [adhereText, nonAdhereText],
    },
    series: [
      {
        name: 'Maintenance Inhaler adherence rate',
        type: 'pie',
        silent: true,
        radius: ['55%', '70%'],
        avoidLabelOverlap: true,
        itemStyle: {},
        label: {
          normal: {
            show: true,
            position: 'center',
            textStyle: {
              color: '#333',
              fontSize: '30',
            },
            formatter: function(params) {
              const { name, value } = params.data
              return `${name} \n ${value}%`
            },
          },
          // emphasis: {
          //   show: true,
          //   textStyle: {
          //     fontSize: '30',
          //     fontWeight: 'bold',
          //   },
          // },
        },
        labelLine: {
          normal: {
            show: false,
          },
        },
        data: [
          {
            value: adherePercent,
            name: adhereText,

            // itemStyle: {color: '006838'}
            itemStyle: { normal: { color: '#5fd0d0' } },
            label: {
              position: 'center',
              textStyle: {
                color: '#74777a',
                fontSize: '40',
                fontWight: 'bold',
                fontFamily: 'Source Sans Pro',
              },
              formatter: function(params) {
                return `${params.percent}%`
              },
            },
          },
          {
            value: nonAdherePercent,
            name: nonAdhereText,
            itemStyle: { color: '#9a3f67' },
            label: { show: false },
          },
        ],
      },
    ],
  }
}
